 <template>
  <div class="info-region-container" style="height: 100vh">
    <div class="all-content-container">
      <div class="info-title-container container-user">
        <div class="title_muen">
          <h4>修改记录</h4>
          <p
            class="backBth"
            style="top: 10px; cursor: pointer"
            @click="canlan()"
          >
            <i class="el-icon-caret-left"></i>
            <span>返回</span>
          </p>
        </div>
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline"
          style="margin-left: 50px"
          label-width="100px;"
        >
          <el-form-item label="修改人：" prop>
            <el-input
              placeholder="请输入修改人"
              maxlength="20"
              v-model="updateName"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="修改时间：" prop="timer">
            <el-date-picker
              class="date_timer"
              v-model="formInline.timer"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button type="button" @click="usrReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="info-content-container">
        <div class="table_content1">
          <el-table
            :data="tableData"
            align="center"
            boder
            class="data-table"
            style="width: 100%; margin-top: 20px"
            v-loading="loading"
            :header-cell-style="{ background: '#f4f5f7' }"
          >
            <el-table-column
              fixed
              prop="cropName"
              align="center"
              label="生长作物"
            ></el-table-column>
            <el-table-column
              prop="oldModelName"
              align="center"
              label="修改前模型"
            ></el-table-column>
            <el-table-column
              prop="newModelName"
              align="center"
              label="修改后模型"
            ></el-table-column>
            <el-table-column
              fixed
              prop="updateName"
              align="center"
              label="修改人"
            ></el-table-column>
            <el-table-column
              fixed="right"
              align="center"
              label="修改时间"
              prop="updateTime"
            ></el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page">
            <!-- <p>
              共
              <span class="pagination-info-text">{{ Math.ceil(total/pagesize) }}</span>页
              <span>/</span>
              <span class="pagination-info-text">{{ total }}</span>条数据
            </p>-->
          </div>
          <div class="pagination-content-container" style="margin-right: 20px">
            <el-pagination
              background
              layout="prev, pager, next,jumper"
              class="pageTap"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 <script>
export default {
  name: "amendantRecord",
  data() {
    return {
      tableData: [],
      id: "",
      currentPage: 1,
      pageSize: 8,
      endTime: "",
      startTime: "",
      updateName: "",
      formInline: {
        timer: [],
      },
      total: 0,
      loading: false,
    };
  },

  computed: {},
  created() {
    this.id = this.$route.query.id;
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.getRoleMessageList(); //列表信息
    },

    // 查询
    onSubmit() {
      this.formInline.timer = this.formInline.timer
        ? this.formInline.timer
        : [];
      this.endTime = this.zhDatetime(this.formInline.timer[1]);
      this.startTime = this.zhDatetime(this.formInline.timer[0]);

      this.getRoleMessageList(); //列表信息
    },
    //分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getRoleMessageList();
    },
    //重置
    usrReset() {
      this.formInline.timer = [];
      this.endTime = "";
      this.startTime = "";
      this.updateName = "";
      this.getRoleMessageList();
    },
    //查询决策模型修改记录列表
    getRoleMessageList() {
      this.loading = true; //开启加载
      this.$api.system
        .getModelDecisionUpdateList(
          this.id,
          this.currentPage,
          this.pageSize,
          this.endTime,
          this.startTime,
          this.updateName
        )
        .then((res) => {
          if (res.code == 200) {
            this.loading = false; //关闭
            this.tableData = res.data;
            this.total = res.count;
          } else {
            this.loading = false; //关闭
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    canlan() {
      this.$router.push({
        path: "decisionManagement",
      });
    },
    //时间转换
    zhDatetime(t) {
      if (t == "" || t == null || t == undefined) {
        return "";
      } else {
        var d = new Date(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        M = M > 9 ? M : "0" + M;
        D = D > 9 ? D : "0" + D;
        h = h > 9 ? h : "0" + h;
        m = m > 9 ? m : "0" + m;
        s = s > 9 ? s : "0" + s;
        return Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-icon-time {
  position: relative;
  top: 1px;
}
.el-range__close-icon {
  position: relative;
  top: -5px;
}
el-input {
  width: 110%;
}
.dialogformInline1 {
  width: 324px;
}
.title_muen {
  position: relative;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  padding: 10px 0;
}
.backBth {
  margin-left: 20px;
}
.date_timer {
  position: relative;
  top: 6 !important;
}
.el-button {
  line-height: 0 !important;
}
.demo-form-inline {
  border-bottom: 1px solid #e8e8e8;
  margin-left: 0 !important;
  padding-left: 50px !important;
}
</style>